import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-location",
  "use": "icon-location-usage",
  "viewBox": "0 0 17 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 22\" id=\"icon-location\"><g transform=\"translate(1 1)\"><path d=\"M7.4 21c-.3 0-.6-.1-.8-.3C1.5 14.7-1 10.3-1 7.4-1 2.8 2.8-1 7.4-1s8.4 3.8 8.4 8.4c0 3-2.5 7.3-7.6 13.3-.3.2-.5.3-.8.3zm0-20C3.9 1 1 3.9 1 7.4 1 9 2.1 12.2 7.4 18.5c5.2-6.3 6.4-9.5 6.4-11.1C13.7 3.9 10.9 1 7.4 1z\" /><circle cx=\"7.4\" cy=\"7.1\" r=\"3.5\" style=\"fill-rule:evenodd;clip-rule:evenodd\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol